import { render, staticRenderFns } from "./AdminCompanyAdmin.vue?vue&type=template&id=62425970"
import script from "./AdminCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./AdminCompanyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports